import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CampaignActiveTab from "./CampaignActiveTab";

class CampaignTabs extends Component {

  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {   
     
      activeTab: this.props.children[0].props.label,
      lastResponse: undefined,
    };
  }

  onClickTabItem = (tab) => {

    this.setState({ activeTab: tab }, () =>
      this.props.LastResponse(this.state.lastResponse)
    );
  };

  render() {
   
     {localStorage.getItem("label") == "Leads" && (                         
                 this.setState({ activeTab: "Leads" } ,
                  localStorage.setItem("label","") ,
                  localStorage.setItem("path","/") 
     ))}
          {localStorage.getItem("label") == "Trigger" && (                         
                 this.setState({ activeTab: "Trigger" } ,
                  localStorage.setItem("label","") ,
                  localStorage.setItem("path","/")
     ))}

    const {
      onClickTabItem,
      props: { children },
      state: { activeTab },
    } = this;

    return (
     
      <div className="tabs">
        <ol className="tab-list">
          {children.map((child) => {
            const { label } = child.props;

            return (
              <CampaignActiveTab
                activeTab={activeTab}
                key={label}
                label={label}
                onClick={onClickTabItem}
              />

              
            );
          })}
        </ol>
        <div className="tab-content">
          {children.map((child) => {
            if (child.props.label !== activeTab) return undefined;
            return child.props.children;
          })}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    LastResponse: (response) =>
      dispatch({ type: "Last_Response", payload: response }),
  };
};

export default connect(null, mapDispatchToProps)(CampaignTabs);
